import Axios, { AxiosError } from "axios";
import Cookies from "js-cookie";

import { signOut } from "@features/auth/slice";

export type ErrorResponse = {
  code: number;
  message: string;
};

export const axios = Axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

export const setUpInterceptor = (store: any) => {
  axios.interceptors.request.use(function (config) {
    // const idToken = store.getState()?.auth?.userInfo?.idToken;
    const domain =
      window.location.hostname === "localhost"
        ? "localhost"
        : process.env.REACT_APP_GATHERLANCE_URL.toString().replace(/(^\w+:|^)\/\//, "");

    const idToken = Cookies.get(`token_${domain}`);
    config.headers.Authorization = `Bearer ${idToken}`;

    return config;
  });

  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      const status = error.response?.status || 500;
      const url = error.config.url;

      if (status === 403) {
        window.location.href = process.env.REACT_APP_GATHERLANCE_URL;
        return;
      }

      if (status === 401 && url !== "/login") {
        store.dispatch(signOut());
        const redirectTo = `${location.pathname}${location.search}`;
        window.location.href = redirectTo
          ? `/sign-in?redirectTo=${redirectTo}`
          : "/sign-in";
      }
      return Promise.reject(error);
    }
  );
};

export const handleApiError = (error: unknown): { success: boolean; message: string } => {
  const err = error as AxiosError<ErrorResponse>;
  let message;
  if (err.response) {
    const {
      response: { data },
    } = err;
    message = data?.message;
    return { success: false, message: data?.message };
  } else {
    message = err.message;
  }

  return { success: false, message };
};
